import { FC } from 'react'
import { PrismicRichText } from '@prismicio/react'
import tw from 'twin.macro'
import { Body, Grid } from '../UI'
import { RichTextFields } from '../../types/prismic'
import CircleBar from '../CircleBar'
import { richTextComponents } from '../../utils/richTextComponents'

type Props = {
  header: string
  subhead: RichTextFields
  item_1_stat: string
  item_1_copy: string
  item_2_stat: string
  item_2_copy: string
  item_3_stat: string
  item_3_copy: string
  source: string
}

const CircleStats: FC<Props> = ({
  header,
  subhead,
  item_1_stat,
  item_1_copy,
  item_2_stat,
  item_2_copy,
  item_3_stat,
  item_3_copy,
  source,
}) => {
  return (
    <section tw="bg-white pt-[56px] pb-[68px] lg:(pt-[74px] pb-[84px]) text-gb-blue font-domaine">
      <Grid>
        {/* Headline content */}
        {header && (
          <div tw="col-span-full lg:(col-span-5)">
            <h2 css={[Body, tw`mb-[15px] lg:mb-[25px]`]}>{header}</h2>
          </div>
        )}
        <div tw="col-span-full mb-8 lg:(col-start-1 col-span-full mb-5 pr-6)">
          <PrismicRichText
            field={subhead.richText}
            components={richTextComponents}
          />
        </div>
        <div tw="col-span-full text-center lg:(col-start-1 col-span-full flex justify-center items-center)">
          <div tw="block justify-start items-center w-full mb-5 lg:(mb-0 block w-[350px])">
            <div tw="relative flex items-center justify-center mr-2 lg:(w-full mx-0 mr-0)">
              <div tw="w-[250px] lg:w-full">
                <CircleBar
                  percentage={100}
                  circleColor={'rgb(255, 77, 194)'}
                  outerStrokeWidth={2}
                />
              </div>
              <p tw="absolute text-center lg:w-[55%]">
                <span tw="text-gb-magenta font-object text-[36px] lg:text-[56px] line-height[1]">
                  {item_1_stat}
                </span>
                <span css={[Body, tw`hidden mt-2 lg:(block)`]}>
                  {item_1_copy}
                </span>
              </p>
            </div>
            <p css={[Body, tw`lg:(hidden)`]}>{item_1_copy}</p>
          </div>
          <div tw="block text-center justify-start items-center w-full mb-5 lg:(mb-0 block w-[350px])">
            <div tw="relative flex items-center justify-center mr-2 lg:(w-full mx-0 mr-0)">
              <div tw="w-[250px] lg:w-full">
                <CircleBar
                  percentage={100}
                  circleColor={'rgb(249, 85, 37)'}
                  outerStrokeWidth={2}
                />
              </div>
              <p tw="absolute text-center lg:w-[55%]">
                <span tw="text-gb-red font-object text-[36px] lg:text-[56px] line-height[1]">
                  {item_2_stat}
                </span>
                <span css={[Body, tw`hidden mt-2 lg:(block)`]}>
                  {item_2_copy}
                </span>
              </p>
            </div>
            <p css={[Body, tw`lg:(hidden)`]}>{item_2_copy}</p>
          </div>
          <div tw="block text-center justify-start items-center w-full lg:(mb-0 block w-[350px])">
            <div tw="relative flex items-center justify-center mr-2 lg:(w-full mx-0 mr-0)">
              <div tw="w-[250px] lg:w-full">
                <CircleBar
                  percentage={100}
                  circleColor={'rgb(25, 23, 156)'}
                  outerStrokeWidth={2}
                />
              </div>
              <p tw="absolute text-center lg:w-[55%]">
                <span tw="text-gb-blue font-object text-[36px] lg:text-[56px] line-height[1]">
                  {item_3_stat}
                </span>
                <span css={[Body, tw`hidden mt-2 lg:(block)`]}>
                  {item_3_copy}
                </span>
              </p>
            </div>
            <p css={[Body, tw`lg:(hidden)`]}>{item_3_copy}</p>
          </div>
        </div>
      </Grid>
    </section>
  )
}

export default CircleStats
